/**
 * He environment platforms reference.
 */
module.exports = {
  STUDIEMEISTER: 'stm',
  HOGES: 'hoges',
};
